import {
    RECEIVE_BAD_REQUEST_POST_USER_SET_PASSWORD,
    RECEIVE_POST_USER_SET_PASSWORD, REQUEST_POST_USER_SET_PASSWORD, SET_USER_SET_PASSWORD_SETTINGS
} from "./index";

export function changeUserSetPasswordSettings(key, value){
    return {
        type: SET_USER_SET_PASSWORD_SETTINGS,
        payload: {
            key,
            value
        }
    }
}


export function requestPostUserSetPassword(sendBody){
    return {
        type: REQUEST_POST_USER_SET_PASSWORD,
        payload: sendBody
    }
}

export function receivePostUserSetPassword(response){
    return {
        type: RECEIVE_POST_USER_SET_PASSWORD,
        payload: response
    }
}
export function receiveBadRequestPostUserSetPassword(payload){
    return {
        type: RECEIVE_BAD_REQUEST_POST_USER_SET_PASSWORD,
        payload
    }
}
